import { transformSearch } from "@/api/helper.ts";
import { queryClient } from "@/query-client.ts";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import courtBranchService from "../services/court-branches-service";

export const courtBranchSearchQuery = z.object({
	search: z.string().optional(),
	court_station_id: z.string(),
	case_id: z.string().nullable().optional(),
	per_page: z.number().optional(),
	page: z.number().nullable().optional(),
});

export const courtBranchesQueryOptions = (
	search?: z.infer<typeof courtBranchSearchQuery>,
	options?: { enabled: boolean },
) => {
	return queryOptions({
		queryKey: ["court_branches", search],
		queryFn: () =>
			courtBranchService.list(
				transformSearch(search, ["court_station_id", "search"]),
			),
		...options,
	});
};

export const courtBranchQueryOptions = (branchId: string) => {
	return queryOptions({
		queryKey: ["court_branches", branchId],
		queryFn: () => courtBranchService.findById(branchId),
	});
};

export const useCourtBranchMutation = (branchId?: string) => {
	return useMutation({
		mutationKey: ["court_branches", branchId],
		mutationFn: courtBranchService.upsert,
		meta: {
			successMessage: "Court Branch saved successfully",
		},
		onSuccess: () =>
			queryClient.invalidateQueries({ queryKey: ["court_branches"] }),
	});
};

export const useCourtBranchDeleteMutation = () => {
	return useMutation({
		mutationKey: ["court_branches", "delete"],
		mutationFn: courtBranchService.deleteById,
		meta: {
			successMessage: "Court Branch archived successfully",
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["court_branches"],
			});
		},
	});
};
